import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import { CodeDiff } from "v-code-diff";
import { ArtifactDeltaDiffProps } from "@/types";
import { isArtifact, isModifiedArtifact, splitIntoLines } from "@/util";
import { Modal } from "@/components/common";


/**
 * Displays artifact delta code diffs.
 */
const __default__ = {
  name: "ArtifactDeltaDiff",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    open: { type: Boolean },
    delta: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const context = 100;
const outputFormat = "line-by-line";
const diffStyle = "word";
const maxWordCount = 15;

const deltaType = computed(() => props.delta.deltaType);

const artifact = computed(() =>
  isArtifact(props.delta.artifact) ? props.delta.artifact : undefined
);
const modification = computed(() =>
  isModifiedArtifact(props.delta.artifact) ? props.delta.artifact : undefined
);

/**
 * Splits a string into separate links.
 * @param str - The strong to split.
 * @return The split string.
 */
function splitLines(str: string): string {
  return splitIntoLines(str, maxWordCount);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    title: `Artifact Changes: ${props.delta.name}`,
    open: props.open,
    size: "lg",
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      (deltaType.value === 'added' && !!artifact.value)
        ? (_openBlock(), _createBlock(_unref(CodeDiff), {
            key: 0,
            "old-string": '',
            "new-string": splitLines(artifact.value.body),
            context: context,
            "output-format": outputFormat,
            "diff-style": diffStyle,
            class: "q-my-none"
          }, null, 8, ["new-string"]))
        : (deltaType.value === 'removed' && !!artifact.value)
          ? (_openBlock(), _createBlock(_unref(CodeDiff), {
              key: 1,
              "old-string": splitLines(artifact.value.body),
              "new-string": '',
              context: context,
              "output-format": outputFormat,
              "diff-style": diffStyle,
              class: "q-my-none"
            }, null, 8, ["old-string"]))
          : (deltaType.value === 'modified' && !!modification.value)
            ? (_openBlock(), _createBlock(_unref(CodeDiff), {
                key: 2,
                "old-string": splitLines(modification.value.before.body),
                "new-string": splitLines(modification.value.after.body),
                context: context,
                "output-format": outputFormat,
                "diff-style": diffStyle,
                class: "q-my-none"
              }, null, 8, ["old-string", "new-string"]))
            : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "open"]))
}
}

})